/* eslint-disable */
export default {
  cancel: 'Cancelar',
  close: 'Cerrar',
  ok: 'Aceptar',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"close"@#@ @source: @#@"Close"@#@
// @key: @#@"ok"@#@ @source: @#@"OK"@#@
